import React from 'react';

import styled from 'styled-components';

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
import { useContextSelector } from 'use-context-selector';
import { ModalProps } from '../../../../../../components/Modal';
import { PlatformContext } from '../../../../../../contexts/PlatformContext';
import { Page, useMainRouter } from '../../../../../../Router/pageComponents';
import ContainerModal from '../../../../../../components/ContainerModal';
import { Button } from '../../../../../../components';

export type SystemUnavailableProps = Pick<ModalProps, 'visible' | 'onClose'>;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: #555658;

  img {
    width: 120px;
    height: 120px;
    align-self: center;
  }

  h3 {
    font-weight: 500;
    font-size: 22px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
  }

  .info {
    font-weight: 400;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
    margin-top: 24px;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`;

export const ConcurrentAppointmentsModal: React.FC<SystemUnavailableProps> = ({ visible, onClose }) => {
  const { clearData } = useContextSelector(PlatformContext, state => state);

  const { navigate } = useMainRouter();

  const openConsultAppointment = () => {
    clearData();
    navigate(Page.CONSULT_APPOINTMENT);
  };

  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      withoutCloseButton={true}
      name="ConcurrentAppointmentsModal"
      childrenFooter={
        <>
          <Button disabled={!visible} type="button" title="Consultar agendamentos" onClick={openConsultAppointment} />
          <Button disabled={!visible} type="button" title="Fechar" onClick={onClose} secondary />
        </>
      }
    >
      <Container>
        <img src={warningIcon} alt="warning" />
        <h3>Você já possui um agendamento para esse serviço</h3>

        <p className="info">Para consultar ou cancelar seu agendamento, acesse:</p>
      </Container>
    </ContainerModal>
  );
};
